module.exports = __webpack_public_path__ + "media/măai kwaam wâa ngai nîa kon jang-wàt năi kon jang-wàt à-rai pûak tân nîa.d6de984f.mp3";